import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const messages = {
  conversations: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/messages/conversations", params),
  chat_messages: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/messages/chat_messages", params),
  message_senders: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/messages/message_senders", params),
  direct_messages: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/messages/direct_messages", params),
  new_dm_conversations: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/messages/new_dm_conversations",
      params,
    ),
  group_chat_messages: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/messages/group_chat_messages",
      params,
    ),
  new_group_chat_conversation: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/messages/new_group_chat_conversation",
      params,
    ),
  chat_space_messages: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/messages/chat_space_messages",
      params,
    ),
  live_room_messages: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/messages/live_room_messages",
      params,
    ),
  most_active_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/messages/most_active_members",
      params,
    ),
  conversations_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/messages/conversations_by_date",
      params,
    ),
};
